module.exports = __webpack_public_path__ + "img/select-click.27df44be.svg";